import {library} from '@fortawesome/fontawesome-svg-core';
import {fab} from '@fortawesome/free-brands-svg-icons';
import {far, faCommentDots} from '@fortawesome/free-regular-svg-icons';
import {fas, faSignOutAlt} from '@fortawesome/free-solid-svg-icons';
import {
  faBars,
  faChartBar,
  faChevronDown,
  faChevronUp,
  faCube,
  faDollarSign,
  faExchangeAlt,
  faEye,
  faFileExport,
  faFileImport,
  faPlus,
  faSearch,
  faShoppingBasket,
  faSortDown,
  faUserFriends,
  faUserTie,
  faCaretDown,
  faInbox,
  faFileInvoice,
  faTags,
  faClipboardCheck,
  faTh,
  faFileInvoiceDollar,
  faPlusCircle,
  faUserCircle,
  faCog,
  faInfoCircle,
  faMapMarkerAlt,
  faDownload,
  faCheckSquare,
  faBarcode,
  faClone,
  faLock,
  faTrashAlt,
  faEllipsisV,
  faSave,
  faBan,
  faFilter,
  faPen,
  faSort,
  faCalendarAlt,
  faMinusCircle,
  faTimes
} from '@fortawesome/free-solid-svg-icons';

library.add(
  fab,
  fas,
  far,
  faEye,
  faCube,
  faExchangeAlt,
  faUserTie,
  faUserFriends,
  faDollarSign,
  faChartBar,
  faShoppingBasket,
  faChevronUp,
  faChevronDown,
  faSearch,
  faSortDown,
  faPlus,
  faFileImport,
  faFileExport,
  faBars,
  faCaretDown,
  faInbox,
  faFileInvoice,
  faTags,
  faClipboardCheck,
  faTh,
  faFileInvoiceDollar,
  faPlusCircle,
  faUserCircle,
  faSignOutAlt,
  faCog,
  faInfoCircle,
  faMapMarkerAlt,
  faDownload,
  faCommentDots,
  faCheckSquare,
  faBarcode,
  faClone,
  faLock,
  faTrashAlt,
  faEllipsisV,
  faSave,
  faBan,
  faFilter,
  faPen,
  faSort,
  faCalendarAlt,
  faMinusCircle,
  faTimes
);
